import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import useGraph from './useGraph/useGraph';
import { StyledGraph } from './Graph.style';
import GraphEmptyState from '../../EmptyState/GraphEmptyState';

const Graph = ({ data, resourceType }) => {
  const graphConfig = useGraph({ data, resourceType });
  const isEmptyState = data?.length === 0;

  if (isEmptyState) return <GraphEmptyState />;

  return (
    <StyledGraph>
      <header>
        Breakdown by FTE (note: percentage does not reflect issue count)
      </header>
      <main>
        <HighchartsReact
          containerProps={{ style: { height: '100%', width: '100%' } }}
          highcharts={Highcharts}
          options={graphConfig}
        />
      </main>
    </StyledGraph>
  );
};

export default Graph;
